<template>
    <Loading v-if="isLoading"/>
    <div class="container" v-else>
        <div class="row">
            <div class="col-12 content">
                <h1 v-if="!isDownloadForm">{{$t('download_list')}}</h1>
                <template v-if="assets.length > 0">
                    <div class="cntl-btn" v-if="!isDownloadForm">
                        <button @click="remove()"
                                style="margin-left: 1rem;padding: .25rem .5rem;background: #9f3c31;color: #fff; font-weight: 400;border-radius: 5px;border: 1px solid #9f3c31;"
                                type="button">{{$t('delete')}}
                        </button>
                    </div>
                    <ul class="download-list">
                        <li v-for="asset in assets" :key="asset.id">
                            <article>
                                <div class="dl-item">
                                    <div class="dl-item-head">
                                        <div class="dl-name">
                                            <h2>{{asset.title}}</h2>
                                            <p><span class="sr-only">{{$t('furigana')}}</span>{{asset.title_reading}}
                                            </p>
                                        </div>
                                        <div class="delete-btn" v-if="!isDownloadForm">
                                            {{$t('delete')}}<input type="checkbox" v-model="selectedAssets[asset.id]"
                                                                   class="checkAsset" :value="asset.id">
                                        </div>
                                    </div>
                                    <div class="dl-item-body">
                                        <div class="dl-item-image">
                                            <img :src="asset.thumbnail_url" :alt="asset.title">
                                        </div>
                                        <div class="dl-item-detail">
                                            <dl>
                                                <dt>ID</dt>
                                                <dd>{{asset.code}}</dd>
                                                <dt>{{$t('prefecture')}}</dt>
                                                <dd>{{asset.prefecture}}</dd>
                                                <dt>{{$t('address')}}</dt>
                                                <dd>{{asset.location}}</dd>
                                                <dt>{{$t('site_name')}}</dt>
                                                <dd>{{asset.asset_site}}</dd>
                                                <dt>{{$t('last_update_date')}}</dt>
                                                <dd>{{asset.modified_date}}</dd>
                                                <dt>URL</dt>
                                                <dd><a :href="asset.url">{{asset.url}}</a></dd>
                                                <dt>{{$t('thumbnail_url')}}</dt>
                                                <dd><a :href="asset.thumbnail_url">{{asset.thumbnail_url}}</a></dd>
                                                <dt>{{$t('content_url')}}</dt>
                                                <dd>{{asset.content_url}}</dd>
                                                <dt>{{$t('content_type')}}</dt>
                                                <dd>{{asset.content_type}}</dd>
                                                <dt>{{$t('category')}}</dt>
                                                <dd>{{asset.asset_category}}</dd>
                                                <dt>{{$t('subcategory')}}</dt>
                                                <dd>{{asset.sub_category}}</dd>
                                                <dt>{{$t('licenses')}}</dt>
                                                <dd v-if="asset.license !== null">
                                                    <a :href="getLicenseUrl(asset.license.slug)" target="blank"
                                                       class="blank">{{asset.license.name}}</a>
                                                </dd>
                                                <dd v-else></dd>
                                                <dt>{{$t('content_release_status')}}</dt>
                                                <dd>{{asset.publish_status}}</dd>
                                            </dl>
                                            <dl>
                                                <dt>{{$t('description')}}</dt>
                                                <dd>{{asset.description}}</dd>
                                                <dt>{{$t('component_part_name')}}</dt>
                                                <dd>{{asset.official_site_name}}</dd>
                                                <dt>{{$t('period')}}</dt>
                                                <dd>{{asset.age}}</dd>
                                                <dt>{{$t('photographer_videographer')}}</dt>
                                                <dd>{{asset.photographer}}</dd>
                                                <dt>{{$t('date_taken_short')}}</dt>
                                                <dd>{{formatDateJa(asset.image_date)}}</dd>
                                                <dt>{{$t('property_holding_organization')}}</dt>
                                                <dd>{{asset.holding_organization}}</dd>
                                                <dt>{{$t('supervisory_organization')}}</dt>
                                                <dd>{{asset.jurisdiction_agency}}</dd>
                                                <dt>{{$t('supervisory_organization_url')}}</dt>
                                                <dd v-if="asset.holding_organization_url !== ''"><a
                                                    :href="asset.holding_organization_url" target="blank" class="blank">{{asset.holding_organization_url}}</a>
                                                </dd>
                                                <dd v-else></dd>
                                                <dt>{{$t('credits')}}</dt>
                                                <dd>{{asset.credit_notation}}</dd>
                                                <dt>{{$t('precautions_for_use')}}</dt>
                                                <dd>{{asset.precautions_for_use}}</dd>
                                                <dt>{{$t('tag')}}</dt>
                                                <dd>{{asset.tags}}</dd>
                                                <dt>{{$t('format')}}</dt>
                                                <dd>{{asset.format}}</dd>
                                                <dt>{{$t('file_size')}}</dt>
                                                <dd>{{asset.file_size}}</dd>
                                                <dt>{{$t('resolution')}}</dt>
                                                <dd>{{asset.resolution}}</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </li>
                    </ul>
                    <div class="cntl-btn" v-if="!isDownloadForm">
                        <button @click="remove()"
                                style="margin-left: 1rem;padding: .25rem .5rem;background: #9f3c31;color: #fff; font-weight: 400;border-radius: 5px;border: 1px solid #9f3c31;"
                                type="button">{{$t('delete')}}
                        </button>
                    </div>
                    <div class="confirmation" v-if="!isDownloadForm">
                        <h3>{{$t('purpose_of_use')}}</h3>
                        <p>{{$t('purpose_of_use_description')}}</p>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-model="download_type" id="business"
                                   value="commercial">
                            <label class="form-check-label" for="business">{{$t('commercial_use')}}</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-model="download_type" id="not-business"
                                   value="none_commercial">
                            <label class="form-check-label" for="not-business">{{$t('non_commercial')}}</label>
                        </div>
                        <p v-html="$t('agree_description')"></p>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-model="accept_status" id="agree"
                                   value="agree">
                            <label class="form-check-label" for="agree">{{$t('agree')}}</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" v-model="accept_status" id="not-agree"
                                   value="not-agree">
                            <label class="form-check-label" for="not-agree">{{$t('disagree')}}</label>
                        </div>
                        <div class="dl-btn">
                            <router-link
                                :to="{name: download_type === 'none_commercial' ? 'AssetNonCommercialDownload' : 'AssetDownloadForm'}"
                                :class="{'not-agree': accept_status === 'not-agree'}">
                                {{download_type === 'none_commercial' ? $t('download_for_non_commercial') : $t('application_form')}}
                            </router-link>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="mt-5 ather-collections">
                        <p class="mb-5 text-center">{{$t('empty_download_list')}}</p>
                        <div class="back-to-search">
                            <router-link class="more-btn" :to="{name: 'ArtifactsList'}">
                                <span>{{$t('return_to_the_archives')}}</span></router-link>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";

export default {
    name: "AssetsDownloadList",
    components: {Loading},
    props: {
        isDownloadForm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            lang: lang,
            assets: [],
            selectedAssets: [],
            home_url: home_url,
            download_type: 'none_commercial',
            accept_status: 'not-agree'
        }
    },
    created() {
        this.getAssetsDownloadList()
    },
    methods: {
        formatDateJa(asset_date) {
            if (asset_date === null) return ''
            if (this.lang === 'ja') {
                return asset_date
            } else {
                asset_date = asset_date.replace('年', '/')
                asset_date = asset_date.replace('月', '/')
                asset_date = asset_date.replace('日', '')
                return asset_date
            }
        },
        getLicenseUrl(license) {
            switch (license) {
                case 'cc-by':
                    return 'https://creativecommons.org/licenses/by/4.0/deed.ja'
                case 'cc-by-nc':
                    return 'https://creativecommons.org/licenses/by-nc/4.0/deed.ja'
                case 'cc-by-nc-nd':
                    return 'https://creativecommons.org/licenses/by-nc-nd/4.0/deed.ja'
                case 'cc-by-nc-sa':
                    return 'https://creativecommons.org/licenses/by-nc-sa/4.0/deed.ja'
                case 'cc-by-nd':
                    return 'https://creativecommons.org/licenses/by-nd/4.0/deed.ja'
                case 'cc-by-sa':
                    return 'https://creativecommons.org/licenses/by-sa/4.0/deed.ja'
                case 'cc0':
                    return 'https://creativecommons.org/publicdomain/zero/1.0/deed.ja'
                default:
                    return 'https://rightsstatements.org/page/InC/1.0/'
            }
        },
        remove() {
            let cart = localStorage.getItem('cart')
            if (cart) {
                let temp = cart.split(',')
                let tempIndex = []
                if (this.selectedAssets.length > 0) {
                    this.selectedAssets.forEach((item, index) => {
                        let idx = temp.indexOf(index.toString())
                        tempIndex.push(index)
                        if (idx > -1) {
                            temp.splice(idx, 1);
                        }
                    })
                    this.assets = this.assets.filter(item => {
                        return !tempIndex.includes(item.id)
                    })
                    localStorage.setItem('cart', temp.join(','))
                }
            }
        },
        getAssetsDownloadList() {
            this.isLoading = true
            let cart = localStorage.getItem('cart')
            const config = {
                params: {
                    ids: cart,
                    lang: this.lang
                }
            }
            axios.get('/api/archives/download-list', config)
                .then((res) => {
                    this.assets = res.data.data
                    if (this.isDownloadForm) {
                        localStorage.removeItem('cart')
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })

        }
    }
}
</script>

<style scoped>

</style>
